/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CaptchaTextLink/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CaptchaTextLink({
  children,
  viewPath = "/DesignSystem/CaptchaInfo/CaptchaTextLink",
  alignSelf,
  disabled,
  onClick,
  goTo,
  target = "_blank",
  marginTop = 0,
  marginLeft = 0,
  marginRight = 0,
  marginBottom = 0,
  text = ""
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="CaptchaTextLink.Vertical"
  data-view-path={viewPath}
 disabled={disabled}
 {...isHoveredBind}
 onClick={onClick}
 target={target}
 style={{'--as-1-Z1qPlXd': alignSelf,'--mt-2-Z1qPlXd': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--ml-3-Z1qPlXd': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-4-Z1qPlXd': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-5-Z1qPlXd': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="CaptchaTextLink.Text"
  data-view-path={viewPath}
 style={{'--td-7-Z1qPlXd': isHovered ? "underline" : disabled ? "none" : "none",'--c-6-Z1qPlXd': disabled ? "normal" : "pointer"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</a>
{children}
</React.Fragment>)
}